import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translation files
import enCommon from './locales/en/common.json';
import enAuth from './locales/en/auth.json';
import enDashboard from './locales/en/dashboard.json';
import enMenu from './locales/en/menu.json';
import enShipments from './locales/en/shipments.json';
import enSettings from './locales/en/settings.json';
import enAiHistory from './locales/en/aiHistory.json';
import enAlerts from './locales/en/alerts.json';
import enForms from './locales/en/forms.json';
import enModals from './locales/en/modals.json';
import enOnboarding from './locales/en/onboarding.json';
import enAirports from './locales/en/airports.json';

import deCommon from './locales/de/common.json';
import deAuth from './locales/de/auth.json';
import deDashboard from './locales/de/dashboard.json';
import deMenu from './locales/de/menu.json';
import deShipments from './locales/de/shipments.json';
import deSettings from './locales/de/settings.json';
import deAiHistory from './locales/de/aiHistory.json';
import deAlerts from './locales/de/alerts.json';
import deForms from './locales/de/forms.json';
import deModals from './locales/de/modals.json';
import deOnboarding from './locales/de/onboarding.json';
import deAirports from './locales/de/airports.json';

import jaCommon from './locales/ja/common.json';
import jaAuth from './locales/ja/auth.json';
import jaDashboard from './locales/ja/dashboard.json';
import jaMenu from './locales/ja/menu.json';
import jaShipments from './locales/ja/shipments.json';
import jaSettings from './locales/ja/settings.json';
import jaAiHistory from './locales/ja/aiHistory.json';
import jaAlerts from './locales/ja/alerts.json';
import jaForms from './locales/ja/forms.json';
import jaModals from './locales/ja/modals.json';
import jaOnboarding from './locales/ja/onboarding.json';
import jaAirports from './locales/ja/airports.json';

import frCommon from './locales/fr/common.json';
import frAuth from './locales/fr/auth.json';
import frDashboard from './locales/fr/dashboard.json';
import frMenu from './locales/fr/menu.json';
import frShipments from './locales/fr/shipments.json';
import frSettings from './locales/fr/settings.json';
import frAiHistory from './locales/fr/aiHistory.json';
import frAlerts from './locales/fr/alerts.json';
import frForms from './locales/fr/forms.json';
import frModals from './locales/fr/modals.json';
import frOnboarding from './locales/fr/onboarding.json';
import frAirports from './locales/fr/airports.json';

import koCommon from './locales/ko/common.json';
import koAuth from './locales/ko/auth.json';
import koDashboard from './locales/ko/dashboard.json';
import koMenu from './locales/ko/menu.json';
import koShipments from './locales/ko/shipments.json';
import koSettings from './locales/ko/settings.json';
import koAiHistory from './locales/ko/aiHistory.json';
import koAlerts from './locales/ko/alerts.json';
import koForms from './locales/ko/forms.json';
import koModals from './locales/ko/modals.json';
import koOnboarding from './locales/ko/onboarding.json';
import koAirports from './locales/ko/airports.json';

i18n
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    // Translation resources
    resources: {
      en: {
        common: enCommon,
        auth: enAuth,
        dashboard: enDashboard,
        menu: enMenu,
        shipments: enShipments,
        settings: enSettings,
        aiHistory: enAiHistory,
        alerts: enAlerts,
        forms: enForms,
        modals: enModals,
        onboarding: enOnboarding,
        airports: enAirports,
      },
      de: {
        common: deCommon,
        auth: deAuth,
        dashboard: deDashboard,
        menu: deMenu,
        shipments: deShipments,
        settings: deSettings,
        aiHistory: deAiHistory,
        alerts: deAlerts,
        forms: deForms,
        modals: deModals,
        onboarding: deOnboarding,
        airports: deAirports,
      },
      ja: {
        common: jaCommon,
        auth: jaAuth,
        dashboard: jaDashboard,
        menu: jaMenu,
        shipments: jaShipments,
        settings: jaSettings,
        aiHistory: jaAiHistory,
        alerts: jaAlerts,
        forms: jaForms,
        modals: jaModals,
        onboarding: jaOnboarding,
        airports: jaAirports,
      },
      fr: {
        common: frCommon,
        auth: frAuth,
        dashboard: frDashboard,
        menu: frMenu,
        shipments: frShipments,
        settings: frSettings,
        aiHistory: frAiHistory,
        alerts: frAlerts,
        forms: frForms,
        modals: frModals,
        onboarding: frOnboarding,
        airports: frAirports,
      },
      ko: {
        common: koCommon,
        auth: koAuth,
        dashboard: koDashboard,
        menu: koMenu,
        shipments: koShipments,
        settings: koSettings,
        aiHistory: koAiHistory,
        alerts: koAlerts,
        forms: koForms,
        modals: koModals,
        onboarding: koOnboarding,
        airports: koAirports,
      },
    },

    // Default language (English)
    lng: 'en',
    fallbackLng: 'en',

    // Default namespace
    defaultNS: 'common',

    // Supported languages
    supportedLngs: ['en', 'de', 'ja', 'fr', 'ko'],

    // React already escapes values
    interpolation: {
      escapeValue: false,
    },

    // Debug mode (set to false in production)
    debug: false,
  });

export default i18n;
